import { supabase } from '@/lib/supabase'

export type RevshareBankAccount = {
  id?: string
  user_id?: string
  holder_name: string
  document?: string | null
  method: 'pix' | 'ted'
  pix_key_type?: string | null
  pix_key_value?: string | null
  bank_code?: string | null
  bank_name?: string | null
  branch?: string | null
  account_number?: string | null
  account_type?: string | null
  is_default?: boolean
  verification_status?: string
}

async function requireUserId(): Promise<string> {
  const userId = (await supabase.auth.getUser()).data.user?.id
  if (!userId) throw new Error('not_authenticated')
  return userId
}

export async function listMyRevshareBankAccounts(): Promise<RevshareBankAccount[]> {
  const userId = await requireUserId()
  const { data, error } = await supabase
    .from('revshare_bank_accounts')
    .select('*')
    .eq('user_id', userId)
    .order('is_default', { ascending: false })
    .order('updated_at', { ascending: false })
  if (error) throw error
  return (data as any) || []
}

export async function listRevshareBankAccountsOf(userId: string): Promise<RevshareBankAccount[]> {
  const { data, error } = await supabase
    .from('revshare_bank_accounts')
    .select('*')
    .eq('user_id', userId)
    .order('is_default', { ascending: false })
    .order('updated_at', { ascending: false })
  if (error) throw error
  return (data as any) || []
}

export async function insertMyRevshareBankAccount(payload: RevshareBankAccount): Promise<string> {
  const userId = await requireUserId()
  const row = { ...payload, user_id: userId, is_default: !!payload.is_default, verification_status: 'pending' }
  const { data, error } = await supabase.from('revshare_bank_accounts').insert(row).select('id').single()
  if (error) throw error
  return (data as any)?.id
}

export async function updateMyRevshareBankAccount(id: string, patch: Partial<RevshareBankAccount>): Promise<void> {
  const userId = await requireUserId()
  const { error } = await supabase
    .from('revshare_bank_accounts')
    .update({ ...patch })
    .eq('id', id)
    .eq('user_id', userId)
  if (error) throw error
}

export async function deleteMyRevshareBankAccount(id: string): Promise<void> {
  const userId = await requireUserId()
  const { error } = await supabase
    .from('revshare_bank_accounts')
    .delete()
    .eq('id', id)
    .eq('user_id', userId)
  if (error) throw error
}

export async function setDefaultMyRevshareBankAccount(id: string): Promise<void> {
  const userId = await requireUserId()
  await supabase
    .from('revshare_bank_accounts')
    .update({ is_default: false })
    .eq('user_id', userId)
    .eq('is_default', true)
    .neq('id', id)
  const { error } = await supabase
    .from('revshare_bank_accounts')
    .update({ is_default: true })
    .eq('id', id)
    .eq('user_id', userId)
  if (error) throw error
}

